import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      const redirect = params.get("redirect") || (u.role === "host" ? "/host" : "/traveler");
      navigate(redirect);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="min-h-screen bg-canvas">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="overline mb-3">Welcome back</div>
        <h1 className="font-serif text-4xl leading-tight">Continue your <span className="italic text-moss">sādhana</span>.</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-xs mb-1.5 block">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-xl bg-white border-subtle" />
          </div>
          <div>
            <Label className="text-xs mb-1.5 block">Password</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-xl bg-white border-subtle" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-destructive">{err}</div>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-moss hover:bg-moss-hover text-canvas py-6">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="flex items-center gap-3 my-6 text-xs text-muted2">
          <div className="flex-1 h-px bg-subtle" /> or <div className="flex-1 h-px bg-subtle" />
        </div>

        <button
          data-testid="login-google"
          onClick={googleLogin}
          className="w-full rounded-full bg-white border border-subtle hover:border-moss py-3.5 text-sm font-medium transition-colors"
        >
          Continue with Google
        </button>

        <p className="text-sm text-muted2 mt-8 text-center">
          New here? <Link data-testid="link-register" to="/register" className="text-moss underline underline-offset-4">Begin your journey</Link>
        </p>
      </div>
    </div>
  );
}
